import React from "react";
import PropTypes from "prop-types";

import {
  Layout,
  Link,
  SectionResultsQuote,
  SectionSteps,
  SectionTextMedia,
  SEO,
  Hero,
  Press,
  SectionThreeCol,
  Highlights,
  SectionTextImageBelow,
} from "components";
import { routes } from "utils/routes";
import { media } from "utils/media";

import contentSEO from "cms/content/index-seo.yml";
import contentHeader from "cms/content/index-header.yml";
import contentSecOne from "cms/content/index-section-one.yml";
import contentSecTwo from "cms/content/index-section-two.yml";
import contentSecThree from "cms/content/index-section-three.yml";
import contentThreeCol from "cms/content/index-three-col.yml";
import contentResults from "cms/content/index-results-quotes.yml";
import contentHighlights from "cms/content/index-highlights.yml";
import contentTextImageBelow from "cms/content/index-text-image-below.yml";

const IndexPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />
    <Link to={routes.apart.path} {...routes.apart} className="cta-sidetab">
      What sets us apart?
    </Link>

    <Hero content={contentHeader} />

    <Press home={true} />
    <SectionTextMedia
      enabled={contentSecOne.enabled}
      title={contentSecOne.title}
      text={contentSecOne.text}
      button={{
        label: contentSecOne.buttonText,
        path: contentSecOne.buttonUrl,
        level: "outline",
      }}
      image={{ url: media(contentSecOne.image), alt: contentSecOne.title }}
      className="bg-img-grid-bl"
    />

    <SectionSteps /> {/* TODO */}

    <SectionThreeCol
      enabled={contentThreeCol.enabled}
      title={contentThreeCol.title}
      colOneImg={media(contentThreeCol.colOneImg)}
      colOneTitle={contentThreeCol.colOneTitle}
      colOneText={contentThreeCol.colOneText}
      colTwoImg={media(contentThreeCol.colTwoImg)}
      colTwoTitle={contentThreeCol.colTwoTitle}
      colTwoText={contentThreeCol.colTwoText}
      colThreeImg={media(contentThreeCol.colThreeImg)}
      colThreeTitle={contentThreeCol.colThreeTitle}
      colThreeText={contentThreeCol.colThreeText}
      buttonUrl={contentThreeCol.buttonUrl}
      buttonText={contentThreeCol.buttonText}
    />
    <SectionTextMedia
      enabled={contentSecTwo.enabled}
      title={contentSecTwo.title}
      subtitle={contentSecTwo.subtitle}
      text={contentSecTwo.text}
      button={{
        label: contentSecTwo.buttonText,
        path: contentSecTwo.buttonUrl,
        level: "outline",
      }}
      image={{ url: media(contentSecTwo.image), alt: contentSecTwo.title }}
      stamp={contentSecTwo.stamp}
      className="bg-img-grid-large"
    />
    <SectionResultsQuote content={contentResults} />

    <SectionTextImageBelow content={contentTextImageBelow} />

    <Highlights content={contentHighlights} />

    <SectionTextMedia
      enabled={contentSecThree.enabled}
      title={contentSecThree.title}
      subtitle={contentSecThree.subtitle}
      text={contentSecThree.text}
      button={{
        label: contentSecThree.buttonText,
        path: contentSecThree.buttonUrl,
        level: "outline",
        external: contentSecThree.buttonExternal,
      }}
      image={{ url: media(contentSecThree.image), alt: contentSecThree.title }}
      className="no-margin mobile-reverse"
    />
  </Layout>
);

IndexPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default IndexPage;
